import gql from 'graphql-tag';

export default gql`
    query GetAssetInfoByLoadId($loadId: Int) {
        getAssetInfoByLoadId(loadId: $loadId) {
            assetTypeId
            assetType
            assetId
            assetDescrip
            quantity
        }
    }
`;
